import React from 'react';
import { arrayOf, func, number, shape, string } from 'prop-types';
import classnames from 'classnames';
import { Select } from 'jl-design-system/components/select/Select';

import styles from './ShopsDropdown.scss';

export const ShopsDropdown = ({ shopList, selectedShopId, onChange, className }) => (
  <div data-testid="ShopsDropdown" className={classnames(styles.ShopsDropdown, className)}>
    <p className={styles.Label}>Shop</p>
    <Select
      id="chosen-shop"
      name="chosen-shop"
      value={selectedShopId}
      className={styles.Select}
      onChange={({ target }) => onChange(shopList.find((shop) => shop.id === target.value))}
    >
      {shopList.map((shop) => (
        <option key={shop.id} value={shop.id}>
          {shop.name}
        </option>
      ))}
    </Select>
  </div>
);

export const MemoizedShopsDropDown = React.memo(ShopsDropdown);

ShopsDropdown.propTypes = {
  shopList: arrayOf(
    shape({
      id: string,
      name: string,
      address: string,
      distance: number,
    }),
  ).isRequired,
  selectedShopId: string.isRequired,
  onChange: func,
  className: string,
};
